import { Button } from "@material-tailwind/react";

export function ButtonDefault() {
  return <Button>Button</Button>;
}
